export const BUSINESS_USERS_RESET_STATE = 'BUSINESS_USERS_RESET_STATE';
export const BUSINESS_USERS_CURRENT_ITEM = 'BUSINESS_USERS_CURRENT_ITEM';

export const BUSINESS_USERS_REQUEST_LOADING = 'BUSINESS_USERS_REQUEST_LOADING';
export const BUSINESS_USERS_REQUEST_SUCCESS = 'BUSINESS_USERS_REQUEST_SUCCESS';
export const BUSINESS_USERS_REQUEST_FAILED = 'BUSINESS_USERS_REQUEST_FAILED';

export const BUSINESS_USERS_CURRENT_ACTION = 'BUSINESS_USERS_CURRENT_ACTION';
export const BUSINESS_USERS_RESET_ACTION = 'BUSINESS_USERS_RESET_ACTION';